<template>
  <div class="datagrid-item">
    <div class="datagrid-title">Код для проверки</div>
    <div class="datagrid-content mt-1"><b>{{ getVal() }}</b></div>
  </div>
</template>

<script>
import {defineComponent} from "vue"

export default defineComponent({
  name: "CodeCheck",
  props: {
    data: {
      type: String,
      require: true,
    },
  },
  setup(props) {
    function getVal() {
      if (props.data["code_to_check"] === null) {
        return "Нет"
      }

      return props.data["code_to_check"]
    }

    return {
      getVal,
    }
  }
})
</script>

<style scoped>

</style>
